module.exports = __webpack_public_path__ + "images/marker-centrum.6b5036.png";